'use client'

import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'

import { cn } from '@dc-shared-web/lib'
import { Icon, IconColor } from '@dc-shared-web/components/base/Icon'
import { faCheck } from '@document-crunch/pro-regular-svg-icons'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'tw-peer tw-border-0 tw-flex tw-justify-center tw-items-center tw-h-4 tw-w-4 tw-shrink-0 tw-rounded-sm tw-ring-offset-background tw-focus-visible:outline-none tw-focus-visible:ring-2 tw-focus-visible:ring-ring tw-focus-visible:ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 tw-data-[state=checked]:bg-primary tw-data-[state=checked]:text-primary-foreground',
      props.checked
        ? 'tw-bg-blue-600 tw-accent-blue-600 hover:tw-bg-blue-600 hover:tw-accent-blue-600'
        : 'tw-border-[1px] tw-border-neutral-200',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn(
        'tw-flex tw-items-center tw-justify-center tw-text-current'
      )}
    >
      <Icon
        icon={faCheck}
        color={IconColor.white}
        className='tw-h-3.5 tw-w-3.5'
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
